module.exports = __webpack_public_path__ + "static/media/connected-apps.e725d76d.png";